var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stock-page-base',{attrs:{"back-route-name":"Point","title-key":"points.stockPageTitle","fetch-stock":_vm.fetchStock,"fetch-products":_vm.fetchProducts}})}
var staticRenderFns = []

export { render, staticRenderFns }